__turbopack_context__.v({
  "not_available_location_container": "styles-module-scss-module__x-RRBW__not_available_location_container",
  "root": "styles-module-scss-module__x-RRBW__root",
});
